import { environment } from '../../environments/environment';

  export const appleAuthConfig = {
    clientId: environment.appleAuthClientId,
    scope: 'email name',
    usePopup: true,
    redirectURI: environment.appleAuthReturnUrl,
  }
